/**
 * Payment utility functions for Dodo payment integration
 */

export type PlanType = 'free' | 'pro' | 'infinity';

/**
 * Extract plan type from URL parameters
 */
export const extractPlanFromUrl = (): PlanType | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const plan = urlParams.get('initiate_plan');
  
  if (plan === 'pro' || plan === 'infinity') {
    return plan;
  }
  
  return null;
};

/**
 * Check if current URL has payment plan parameter
 */
export const hasPaymentPlan = (): boolean => {
  return extractPlanFromUrl() !== null;
};

/**
 * Check if URL has any payment-related parameters
 */
export const hasPaymentParams = (): boolean => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('initiate_plan');
};

/**
 * Check if payment should be initiated based on authentication and setup status
 */
export const shouldInitiatePayment = (
  isAuthenticated: boolean,
  hasBusinessSetup: boolean,
  pendingPlan: PlanType | null,
  paymentCompleted: boolean
): boolean => {
  return !!(
    pendingPlan && 
    !paymentCompleted && 
    isAuthenticated && 
    (hasBusinessSetup || true) // Payment should happen before account setup
  );
};
